/**
 * "Product data is not connected."
 *
 * The CRM signs in to its own project; product data lives in another one, and a
 * Google credential cannot be replayed across the boundary — a token carries the
 * audience of the OAuth client that minted it, and each project only accepts its
 * own. So the product session is established by its own popup, which browsers
 * only allow from a real click. Hence a button rather than something automatic.
 *
 * It is a banner and not a blocking dialog on purpose: leads, events and the
 * whole pipeline live in the CRM's own project and work perfectly without this.
 * Only the product-backed columns are affected, and they already render "—".
 */
import { useAuth } from './AuthProvider'
import './ProductConnectBanner.css'

export function ProductConnectBanner() {
  const { status, productConnected, connectProductData, productError } = useAuth()

  if (status !== 'authorized' || productConnected) return null

  return (
    <div className="pcb" role="status">
      <span className="pcb__dot" aria-hidden="true" />
      <div className="pcb__text">
        <strong>Product data not connected.</strong> App users, Skida PRO companies and route
        counts come from the product’s own Firebase project and need a separate sign-in. Everything
        the CRM owns — leads, events, the pipeline — is unaffected.
        {productError && <div className="pcb__error">{productError}</div>}
      </div>
      <button className="pcb__btn" onClick={() => void connectProductData()}>
        Connect
      </button>
    </div>
  )
}
